{
  "{account} needs to sign in again.": "{account} tiene que volver a iniciar sesión.",
  "{account} no longer has access to Johku Hub.": "{account} ya no tiene acceso a Johku Hub.",
  "{done} of {total}": "{done} de {total}",
  "{left} of {total} left": "Quedan {left} de {total}",
  "{n} by email": "{n} por correo",
  "{n} by push": "{n} por notificación",
  "{n} customer waiting for a reply": "{n} cliente espera respuesta",
  "{n} customers waiting for a reply": "{n} clientes esperan respuesta",
  "{n} let in on this phone": "{n} dejados entrar con este teléfono",
  "{n} message": "{n} mensaje",
  "{n} message hasn't been sent yet and will be lost.": "{n} mensaje aún no se ha enviado y se perderá.",
  "{n} messages": "{n} mensajes",
  "{n} messages haven't been sent yet and will be lost.": "{n} mensajes aún no se han enviado y se perderán.",
  "{n} more: search by name.": "{n} más: busca por nombre.",
  "{n} of {total}": "{n} de {total}",
  "{n} pcs": "{n} uds.",
  "{n} shop chosen": "{n} tienda elegida",
  "{n} shops chosen": "{n} tiendas elegidas",
  "{n} ticket": "{n} entrada",
  "{n} tickets": "{n} entradas",
  "{n} unread": "{n} sin leer",
  "{n} unread conversation": "{n} conversación sin leer",
  "{n} unread conversations": "{n} conversaciones sin leer",
  "{n} use left": "Queda {n} uso",
  "{n} uses left": "Quedan {n} usos",
  "{name} ({n} member)": "{name} ({n} miembro)",
  "{name} ({n} members)": "{name} ({n} miembros)",
  "{name} and {n} more": "{name} y {n} más",
  "{name} sent you a message in Johku Hub ({subject}).": "{name} te ha enviado un mensaje en Johku Hub ({subject}).",
  "{name} sent you a message in Johku Hub.": "{name} te ha enviado un mensaje en Johku Hub.",
  "{shop} can sell its products in your sales channel. Once they accept, Johku puts it into effect.": "{shop} puede vender sus productos en tu canal de venta. Cuando acepten, Johku lo activará.",
  "{shop} sent you a message about your order {order}.": "{shop} te ha enviado un mensaje sobre tu pedido {order}.",
  "{shop} would like to talk with you. Reply or accept to continue.": "{shop} quiere hablar con vosotros. Responde o acepta para continuar.",
  "{sold} of {seats} sold": "{sold} de {seats} vendidas",
  "{used} of {total} let in": "{used} de {total} han entrado",
  "A Bluetooth or USB scanner that types the code, as in the POS's ticket reader.": "Un escáner Bluetooth o USB que escribe el código, como en el lector de entradas de la caja.",
  "About Johku": "Acerca de Johku",
  "Accept": "Aceptar",
  "Accepted the offer: {channel}, {commission} % commission.": "Aceptó la oferta: {channel}, comisión del {commission} %.",
  "Accepted, being put into effect in Johku": "Aceptada, activándose en Johku",
  "Accepted, but Johku couldn't put it into effect: {error}": "Aceptada, pero Johku no pudo activarla: {error}",
  "Accepted, in effect in Johku": "Aceptada, activa en Johku",
  "Access and instructions": "Instrucciones de acceso y uso",
  "Accounts": "Cuentas",
  "Accounts and settings": "Cuentas y ajustes",
  "Add account": "Añadir cuenta",
  "Add an account": "Añadir una cuenta",
  "All": "Todos",
  "All caught up": "Todo leído",
  "All incidents": "Todas las incidencias",
  "All orders": "Todos los pedidos",
  "All shops": "Todas las tiendas",
  "All your shops ({n})": "Todas tus tiendas ({n})",
  "Allow": "Permitir",
  "Allow {app} to use Johku Hub?": "¿Permitir que {app} use Johku Hub?",
  "Already used": "Ya utilizada",
  "an assistant": "un asistente",
  "An assistant asks to use your Johku Hub conversations. Sign in first.": "Un asistente pide usar tus conversaciones de Johku Hub. Inicia sesión primero.",
  "As {name}": "Como {name}",
  "Ask the shop": "Pregunta a la tienda",
  "Attach a file": "Adjuntar un archivo",
  "Back": "Volver",
  "Between organisations": "Entre organizaciones",
  "Booking": "Reserva",
  "Can't load the collections right now.": "No se pueden cargar las colecciones ahora mismo.",
  "Can't load the list of organisations right now.": "Ahora mismo no se puede cargar la lista de organizaciones.",
  "Can't reach Johku Hub. Check your connection and try again.": "No se puede conectar con Johku Hub. Comprueba tu conexión e inténtalo de nuevo.",
  "Cancel": "Cancelar",
  "Cancelled": "Cancelado",
  "Cause found, being fixed": "Causa encontrada, en reparación",
  "Check in": "Check-in",
  "Check out": "Check-out",
  "Check-in opens {time}.": "El check-in se abre {time}.",
  "Checked in {time}": "Check-in realizado {time}",
  "Checked out {time}": "Check-out realizado {time}",
  "Checking in…": "Haciendo el check-in…",
  "Checking out…": "Haciendo el check-out…",
  "Checking the ticket…": "Comprobando la entrada…",
  "Choose a conversation": "Elige una conversación",
  "Choose resources and start times": "Elige recursos y horas de inicio",
  "Choose the seats to let in": "Elige los asientos que entran",
  "Choose the shows to scan for": "Elige las funciones que vas a escanear",
  "Chosen shops": "Tiendas elegidas",
  "Close": "Cerrar",
  "Code sent to {email}": "Código enviado a {email}",
  "Codes": "Códigos",
  "Commission (%)": "Comisión (%)",
  "Confirmed": "Confirmado",
  "Conversation": "Conversación",
  "Conversation with the shop": "Conversación con la tienda",
  "Conversations with the Johku team and shops show up here.": "Aquí aparecen las conversaciones con el equipo de Johku y con las tiendas.",
  "Copied": "Copiado",
  "Copy the code": "Copiar el código",
  "customer": "cliente",
  "Customer": "Cliente",
  "Decline": "Rechazar",
  "Declined": "Rechazada",
  "Declined the offer.": "Rechazó la oferta.",
  "Deny": "Denegar",
  "Done": "Hecho",
  "Download": "Descargar",
  "Downloading {name}": "Descargando {name}",
  "E.g. Card payments fail": "P. ej. Fallan los pagos con tarjeta",
  "Each member gets it in a conversation of their own with the shop, and their replies come to you one by one.": "Cada miembro lo recibe en su propia conversación con la tienda, y sus respuestas te llegan una a una.",
  "Email address": "Correo electrónico",
  "Email those who don't have the app": "Enviar un correo a quienes no tienen la app",
  "Event times, cancellations and the shop's replies.": "Horarios de eventos, cancelaciones y respuestas de la tienda.",
  "Every shop": "Todas las tiendas",
  "Everything you've bought from Johku shops, in one place.": "Todo lo que has comprado en tiendas Johku, en un solo lugar.",
  "Expired {date}": "Caducó el {date}",
  "Find a shop": "Buscar una tienda",
  "Fixed, monitoring": "Solucionado, en observación",
  "For": "Para",
  "For every shop": "Para todas las tiendas",
  "For: {shops}": "Para: {shops}",
  "Get started": "Primeros pasos",
  "Get told about new messages": "Recibe avisos de mensajes nuevos",
  "Getting the shows…": "Cargando las funciones…",
  "Getting the tickets…": "Cargando las entradas…",
  "Gift cards and other codes you buy from Johku shops show up here.": "Aquí aparecen las tarjetas regalo y otros códigos que compres en tiendas Johku.",
  "Hide": "Ocultar",
  "Hide used and expired codes": "Ocultar códigos usados y caducados",
  "Home": "Inicio",
  "Hub may not use the camera. Allow it in the phone's settings.": "Hub no puede usar la cámara. Permítelo en los ajustes del teléfono.",
  "In messages": "En los mensajes",
  "Incidents": "Incidencias",
  "Incidents in Johku": "Incidencias en Johku",
  "Investigating": "En investigación",
  "It is valid for 10 minutes. If you didn't ask for it, you can ignore this email.": "Es válido durante 10 minutos. Si no lo has pedido, puedes ignorar este correo.",
  "It opens signed in, and stays open in the background": "Se abre con la sesión iniciada y sigue abierta en segundo plano",
  "It sees only what you see in Johku Hub, and every use is logged.": "Solo ve lo que tú ves en Johku Hub y cada uso queda registrado.",
  "Johku account": "Cuenta de Johku",
  "Johku agreement": "Contrato de Johku",
  "Johku App": "Johku App",
  "Johku Hub isn't working right now. Try again in a moment.": "Johku Hub no funciona ahora mismo. Inténtalo de nuevo en un momento.",
  "Johku Hub sign-in code: {code}": "Código de acceso a Johku Hub: {code}",
  "Johku status: {title}": "Estado de Johku: {title}",
  "Kind of conversation": "Tipo de conversación",
  "Know when things change": "Entérate cuando algo cambie",
  "Language": "Idioma",
  "Let in {n}": "Dejar entrar ({n})",
  "Let in: {n} seat": "Entrada: {n} asiento",
  "Let in: {n} seats": "Entrada: {n} asientos",
  "Light off": "Apagar la luz",
  "Light on": "Encender la luz",
  "Loading…": "Cargando…",
  "Main menu": "Menú principal",
  "Maintenance": "Mantenimiento",
  "Make an offer": "Hacer una oferta",
  "Members of": "Miembros de",
  "Members' replies come as conversations of their own.": "Las respuestas de los miembros llegan como conversaciones propias.",
  "Message": "Mensaje",
  "Message (optional)": "Mensaje (opcional)",
  "Message the seller about your order and get told when they reply.": "Escribe al vendedor sobre tu pedido y recibe un aviso cuando responda.",
  "Message to {shop}": "Mensaje para {shop}",
  "Message to the shops": "Mensaje a las tiendas",
  "Messages": "Mensajes",
  "Messages can't be reached right now.": "No se puede acceder a los mensajes en este momento.",
  "My Johku": "My Johku",
  "Name, sign-in and deleting the account": "Nombre, inicio de sesión y eliminación de la cuenta",
  "New conversation": "Nueva conversación",
  "New incident": "Nueva incidencia",
  "New message from {name} in Johku Hub": "Nuevo mensaje de {name} en Johku Hub",
  "New message from {shop}": "Nuevo mensaje de {shop}",
  "New message: {shop}, order {order}": "Nuevo mensaje: {shop}, pedido {order}",
  "New messages in Johku Hub": "Mensajes nuevos en Johku Hub",
  "Next up": "Lo próximo",
  "No connection. Check the connection and try again.": "Sin conexión. Comprueba la conexión e inténtalo de nuevo.",
  "No conversations yet": "Aún no hay conversaciones",
  "No conversations yet. Start one with the pen above.": "Aún no hay conversaciones. Empieza una con el lápiz de arriba.",
  "No email? It can take a minute. Check the spam folder too.": "¿No te ha llegado el correo? Puede tardar un minuto. Revisa también la carpeta de spam.",
  "No incidents in the last 30 days.": "No hay incidencias en los últimos 30 días.",
  "No matches.": "Sin resultados.",
  "No messages about this order yet. The customer gets an email with a link to the order page, where they can read and reply.": "Aún no hay mensajes sobre este pedido. El cliente recibe un correo con un enlace a la página del pedido, donde puede leer y responder.",
  "No messages yet": "Aún no hay mensajes",
  "No messages yet.": "Aún no hay mensajes.",
  "No shows match.": "Ninguna función coincide.",
  "No tickets start today for these.": "Hoy no empieza ninguna entrada para estos.",
  "No valid codes": "No hay códigos válidos",
  "None of the shop's collections has members yet.": "Ninguna colección de la tienda tiene miembros todavía.",
  "Not a valid ticket": "Entrada no válida",
  "Not sent: {error}": "No enviado: {error}",
  "Not shown yet": "Aún no visible",
  "Not working": "No funciona",
  "Nothing matches “{query}”.": "Nada coincide con «{query}».",
  "Nothing to scan from today on.": "No hay nada que escanear a partir de hoy.",
  "Notice": "Aviso",
  "Notifications are blocked for this site in the browser's settings.": "Las notificaciones están bloqueadas para este sitio en la configuración del navegador.",
  "Notifications are off for Johku Hub in the phone's settings.": "Las notificaciones de Johku Hub están desactivadas en los ajustes del teléfono.",
  "Notifications of new messages: {name}": "Notificaciones de mensajes nuevos: {name}",
  "Now": "Ahora",
  "Offer a sales channel": "Ofrecer un canal de venta",
  "Offer: sell your products in {channel} with a {commission} % commission.": "Oferta: vended vuestros productos en {channel} con una comisión del {commission} %.",
  "Offline": "Sin conexión",
  "Offline. {n} message will send when the connection returns.": "Sin conexión. {n} mensaje se enviará cuando vuelva la conexión.",
  "Offline. {n} messages will send when the connection returns.": "Sin conexión. {n} mensajes se enviarán cuando vuelva la conexión.",
  "Offline. Messages will send when the connection returns.": "Sin conexión. Los mensajes se enviarán cuando vuelva la conexión.",
  "Offline. These are the codes saved on this phone ({time}).": "Sin conexión. Estos son los códigos guardados en este teléfono ({time}).",
  "Offline. These are the orders saved on this phone.": "Sin conexión. Estos son los pedidos guardados en este teléfono.",
  "Offline. These are the tickets saved on this phone ({time}).": "Sin conexión. Estas son las entradas guardadas en este teléfono ({time}).",
  "OK": "OK",
  "One use": "Un uso",
  "Only for {name}: check their ID.": "Solo para {name}: comprueba su documento.",
  "Only the shop's users who can use the POS can scan its tickets.": "Solo los usuarios de la tienda que pueden usar la caja pueden escanear sus entradas.",
  "Only your own sign-in: your shop and its Johku agreement are managed in Johku App.": "Solo tu acceso personal: tu tienda y su contrato de Johku se gestionan en Johku App.",
  "Open Johku App": "Abrir Johku App",
  "Open the order": "Abrir el pedido",
  "Open the order in the shop": "Abrir el pedido en la tienda",
  "Opening…": "Abriendo…",
  "Opens in a new tab": "Se abre en una pestaña nueva",
  "Order": "Pedido",
  "Order {id}": "Pedido {id}",
  "Orders": "Pedidos",
  "Other merchants": "Otros comerciantes",
  "Other merchants find {shop}": "Otros comerciantes encuentran {shop}",
  "Other orders": "Otros pedidos",
  "Paid": "Pagado",
  "Partly working": "Funciona en parte",
  "Pictures, PDF, text, Word and Excel files only": "Solo imágenes y archivos PDF, de texto, Word y Excel",
  "PIN code": "Código PIN",
  "PIN codes": "Códigos PIN",
  "Point the camera at a ticket's code.": "Apunta la cámara al código de una entrada.",
  "Privacy policy": "Política de privacidad",
  "Private message": "Mensaje privado",
  "Questions about your order? The shop's answer comes to Messages.": "¿Preguntas sobre tu pedido? La respuesta de la tienda llega a Mensajes.",
  "Read and reply: {url}": "Lee y responde: {url}",
  "Read and search your conversations": "Leer y buscar en tus conversaciones",
  "Reader settings": "Ajustes del lector",
  "Ready for the next ticket.": "Listo para la siguiente entrada.",
  "Recent": "Recientes",
  "Recipient": "Destinatario",
  "Refunded": "Reembolsado",
  "Reload": "Recargar",
  "Remove": "Eliminar",
  "Reply in the Johku app or at {url}, signed in with this email address.": "Responde en la app de Johku o en {url}, con la sesión iniciada con esta dirección de correo.",
  "Resolved": "Resuelto",
  "Resolved: {title}": "Resuelto: {title}",
  "Resources": "Recursos",
  "Row {row}, seat {seat}": "Fila {row}, asiento {seat}",
  "Row {row}, seats {seats}": "Fila {row}, asientos {seats}",
  "Sales channel offer": "Oferta de canal de venta",
  "Save": "Guardar",
  "Saved in Downloads": "Guardado en Descargas",
  "Saving files needs Android 10 or newer": "Para guardar archivos se necesita Android 10 o posterior",
  "Scan a ticket with your scanner.": "Escanea una entrada con tu escáner.",
  "Scan for {n} show": "Escanear para {n} función",
  "Scan for {n} shows": "Escanear para {n} funciones",
  "Scan for {n} start time": "Escanear para {n} hora de inicio",
  "Scan for {n} start times": "Escanear para {n} horas de inicio",
  "Scan tickets": "Escanear entradas",
  "Search": "Buscar",
  "Search by name": "Buscar por nombre",
  "Search conversations": "Buscar conversaciones",
  "Search shows": "Buscar funciones",
  "Seat": "Asiento",
  "Seat {seat}": "Asiento {seat}",
  "Seats {seats}": "Asientos {seats}",
  "See all": "Ver todo",
  "Sell, check tickets and answer customers in Johku App.": "Vende, comprueba entradas y responde a los clientes en Johku App.",
  "Send": "Enviar",
  "Send as": "Enviar como",
  "Send code": "Enviar código",
  "Send messages and start conversations as you": "Enviar mensajes e iniciar conversaciones en tu nombre",
  "Send now": "Enviar ahora",
  "Send the offer": "Enviar la oferta",
  "Send to members": "Enviar a los miembros",
  "Send to shops": "Enviar a las tiendas",
  "Send update": "Enviar actualización",
  "Sending…": "Enviando…",
  "Sent to {done} of {n} people": "Enviado a {done} de {n} personas",
  "Sent to {done} of {n} person": "Enviado a {done} de {n} persona",
  "Severity": "Gravedad",
  "Shop": "Tienda",
  "Show booking": "Ver la reserva",
  "Show conversations of": "Mostrar conversaciones de",
  "Show more": "Ver más",
  "Show orders of": "Mostrar pedidos de",
  "Show the code at the door.": "Muestra el código en la entrada.",
  "Show the code at the till, or type it in the shop's online store.": "Muestra el código en caja o escríbelo en la tienda online.",
  "Show tickets": "Ver entradas",
  "Show used and expired codes": "Mostrar códigos usados y caducados",
  "Shows": "Sesiones",
  "Sign in": "Iniciar sesión",
  "Sign in again": "Iniciar sesión de nuevo",
  "Sign in to Johku Hub": "Inicia sesión en Johku Hub",
  "Sign in with an email code": "Iniciar sesión con un código por correo",
  "Sign in with Johku": "Iniciar sesión con Johku",
  "Sign out": "Cerrar sesión",
  "Sign out of {email}? Its messages are removed from this device.": "¿Cerrar sesión en {email}? Sus mensajes se eliminarán de este dispositivo.",
  "Sign out of this account": "Cerrar sesión en esta cuenta",
  "Sign out?": "¿Cerrar sesión?",
  "Signing in with Johku didn't finish. Please try again.": "El inicio de sesión con Johku no terminó. Inténtalo de nuevo.",
  "Signing in with Johku didn't work ({error}).": "El inicio de sesión con Johku no funcionó ({error}).",
  "Signing in…": "Iniciando sesión…",
  "So you see customers' questions right away": "Para que veas enseguida las preguntas de los clientes",
  "Some shops didn't answer, so their codes may be missing: {shops}": "Algunas tiendas no respondieron, así que pueden faltar sus códigos: {shops}",
  "Someone": "Alguien",
  "Something went wrong.": "Algo ha salido mal.",
  "Something went wrong. Please try again.": "Ha ocurrido un error. Inténtalo de nuevo.",
  "Something went wrong. Try again in a moment.": "Algo salió mal. Inténtalo de nuevo en un momento.",
  "Sounds": "Sonidos",
  "Start the conversation": "Iniciar la conversación",
  "Start times today": "Horas de inicio hoy",
  "Status": "Estado",
  "Subject (optional)": "Asunto (opcional)",
  "Support": "Ayuda",
  "Swipe for the next one": "Desliza para ver la siguiente",
  "Switch camera": "Cambiar de cámara",
  "Switch shop": "Cambiar de tienda",
  "That code has expired. Ask for a new one.": "Ese código ha caducado. Pide uno nuevo.",
  "That code isn't right. Check it and try again.": "Ese código no es correcto. Compruébalo e inténtalo de nuevo.",
  "That didn't go through. Try again in a moment.": "No se ha podido. Inténtalo de nuevo en un momento.",
  "The booking isn't confirmed.": "La reserva no está confirmada.",
  "The camera didn't start.": "La cámara no se inició.",
  "The code is on its way. Check again in a moment.": "El código está en camino. Vuelve a mirar en un momento.",
  "The conversation was declined.": "La conversación fue rechazada.",
  "The device's language": "Idioma del dispositivo",
  "The download failed": "La descarga ha fallado",
  "The file is larger than 20 MB": "El archivo ocupa más de 20 MB",
  "The Johku team": "El equipo de Johku",
  "The Johku team keeps you posted here until it's resolved.": "El equipo de Johku te mantendrá informado aquí hasta que se resuelva.",
  "The order page can't be opened right now. Try again in a moment.": "Ahora mismo no se puede abrir la página del pedido. Inténtalo de nuevo en un momento.",
  "The PIN code and instructions show from {time}.": "El código PIN y las instrucciones se muestran a partir del {time}.",
  "The shop can't be reached about this order from here. Try its order page.": "Desde aquí no se puede contactar con la tienda sobre este pedido. Prueba desde la página del pedido.",
  "The ticket couldn't be confirmed. Scan it again.": "No se pudo confirmar la entrada. Escanéala de nuevo.",
  "The ticket is for {what}.": "La entrada es para {what}.",
  "The ticket is for another place.": "La entrada es para otro lugar.",
  "The ticket is for another shop.": "La entrada es de otra tienda.",
  "The ticket is for another show.": "La entrada es para otra función.",
  "The ticket is for another time.": "La entrada es para otra hora.",
  "The tickets can't be opened right now. Try again in a moment.": "Ahora mismo no se pueden abrir las entradas. Inténtalo de nuevo en un momento.",
  "There's no one {name} can write to yet.": "Todavía no hay nadie a quien {name} pueda escribir.",
  "These tickets aren't available any more.": "Estas entradas ya no están disponibles.",
  "this account": "esta cuenta",
  "This browser can't read codes with the camera. Use the Johku Hub app, or a scanner (settings).": "Este navegador no puede leer códigos con la cámara. Usa la app Johku Hub o un escáner (ajustes).",
  "This device has no camera.": "Este dispositivo no tiene cámara.",
  "This goes now to the staff of {n} shop, by push and email. Send it?": "Esto se enviará ahora al personal de {n} tienda, por notificación y correo. ¿Enviar?",
  "This goes now to the staff of {n} shops, by push and email. Send it?": "Esto se enviará ahora al personal de {n} tiendas, por notificación y correo. ¿Enviar?",
  "This goes now to the staff of every shop, by push and email. Send it?": "Esto se enviará ahora al personal de todas las tiendas, por notificación y correo. ¿Enviar?",
  "This incident isn't shown any more.": "Esta incidencia ya no se muestra.",
  "This order has been cancelled. Its tickets aren't valid.": "Este pedido se ha cancelado. Sus entradas no son válidas.",
  "This order has been refunded. Its tickets aren't valid.": "Este pedido se ha reembolsado. Sus entradas no son válidas.",
  "Ticket": "Entrada",
  "Ticket {n} of {total}": "Entrada {n} de {total}",
  "Tickets": "Entradas",
  "Tickets at hand": "Tus entradas, siempre a mano",
  "To (email)": "Para (correo)",
  "To members": "A los miembros",
  "To the members of {collection}: {n} member": "A los miembros de {collection}: {n} miembro",
  "To the members of {collection}: {n} members": "A los miembros de {collection}: {n} miembros",
  "To the members of {collection}: sending, {sent}/{n}": "A los miembros de {collection}: enviando, {sent}/{n}",
  "Today": "Hoy",
  "Tomorrow": "Mañana",
  "Total": "Total",
  "Try again": "Reintentar",
  "Turn on notifications": "Activar notificaciones",
  "Unpaid": "Sin pagar",
  "Upcoming": "Próximos",
  "Update to the shops": "Actualización para las tiendas",
  "Use a scanner instead of the camera": "Usar un escáner en lugar de la cámara",
  "Use another address": "Usar otra dirección",
  "Used": "Utilizado",
  "Uses": "Usos",
  "Valid from {date}": "Válido desde el {date}",
  "Valid until {date}": "Válido hasta el {date}",
  "Validity": "Validez",
  "Value left": "Valor restante",
  "Venue": "Lugar",
  "Vibration": "Vibración",
  "Waiting for {shop} to accept the conversation.": "Esperando a que {shop} acepte la conversación.",
  "Waiting for an answer": "Esperando respuesta",
  "We'll email you a sign-in code. Use the address you use with Johku.": "Te enviaremos un código de acceso por correo. Usa la dirección que usas con Johku.",
  "What doesn't work, who it concerns, what to do meanwhile.": "Qué no funciona, a quién afecta y qué hacer mientras tanto.",
  "What you offer, and what kind of partners you look for": "Qué ofrecéis y qué tipo de socios buscáis",
  "What's wrong": "Qué falla",
  "When": "Cuándo",
  "When something in Johku doesn't work, and when it's fixed": "Cuando algo en Johku no funciona, y cuando se ha solucionado",
  "When you buy from a Johku shop with {email}, the order appears here on its own.": "Cuando compres en una tienda Johku con {email}, el pedido aparecerá aquí automáticamente.",
  "When you buy from a Johku shop with your email, the order appears here on its own.": "Cuando compres en una tienda Johku con tu correo, el pedido aparecerá aquí automáticamente.",
  "Whether other Johku merchants find your shop and can invite it to a conversation": "Si otros comerciantes de Johku encuentran tu tienda y pueden invitarla a una conversación",
  "With the customer": "Con el cliente",
  "With your email, Google or Microsoft, as in Johku's online shops.": "Con tu correo, Google o Microsoft, como en las tiendas online de Johku.",
  "Withdraw the offer": "Retirar la oferta",
  "Withdrawn": "Retirada",
  "Withdrew the offer.": "Retiró la oferta.",
  "Write a message": "Escribe un mensaje",
  "Write to the customer": "Escribe al cliente",
  "Write to the shop": "Escribe a la tienda",
  "Yesterday": "Ayer",
  "You": "Tú",
  "You can close this page.": "Puedes cerrar esta página.",
  "You get this because you work for a shop on Johku. Follow the situation in the Johku app or at {url}.": "Recibes esto porque trabajas en una tienda que usa Johku. Sigue la situación en la app de Johku o en {url}.",
  "You: ": "Tú: ",
  "You'll see replies without opening the app.": "Verás las respuestas sin abrir la app.",
  "You're offline. A new conversation needs a connection.": "No tienes conexión. Una nueva conversación necesita conexión.",
  "You're offline. Checking in and out needs a connection.": "No tienes conexión. El check-in y el check-out necesitan conexión.",
  "You're offline. The first message needs a connection.": "No tienes conexión. El primer mensaje necesita conexión.",
  "You're offline. Try again when the connection returns.": "Sin conexión. Inténtalo de nuevo cuando vuelva la conexión.",
  "You're staff at {shop}": "Formas parte del personal de {shop}",
  "Your codes can't be loaded right now. Try again in a moment.": "Ahora mismo no se pueden cargar tus códigos. Inténtalo de nuevo en un momento.",
  "Your conversations with shops about your orders show up here.": "Aquí aparecen tus conversaciones con las tiendas sobre tus pedidos.",
  "Your Johku account doesn't have access to Johku Hub yet.": "Tu cuenta de Johku aún no tiene acceso a Johku Hub.",
  "Your Johku Hub sign-in code is {code}.": "Tu código de acceso a Johku Hub es {code}.",
  "Your orders": "Tus pedidos",
  "Your orders can't be loaded right now. Try again in a moment.": "Ahora mismo no se pueden cargar tus pedidos. Inténtalo de nuevo en un momento.",
  "Your other accounts stay signed in.": "Tus otras cuentas siguen con la sesión iniciada.",
  "Your other accounts stay signed in. Switch between them from your picture on Home.": "Tus otras cuentas siguen con la sesión iniciada. Cambia entre ellas desde tu imagen en Inicio.",
  "Your session for {account} has ended. Please sign in again.": "Tu sesión de {account} ha terminado. Vuelve a iniciar sesión.",
  "Your shop": "Tu tienda",
  "Your shop has no sales channel in Johku. Set one up in the Johku app's settings first.": "Tu tienda no tiene canal de venta en Johku. Configúralo primero en los ajustes de la app de Johku.",
  "Your shops": "Tus tiendas",
  "Your tickets will show up here": "Tus entradas aparecerán aquí",
  "Your tickets, orders and messages with shops": "Tus entradas, pedidos y mensajes con tiendas"
}
